module.exports = __webpack_public_path__ + "static/media/logo_mvg_transparent.dd6e256d.png";